const NavItems: Array<{ title: string; path: string }> = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Units',
    path: '/units',
  },
  {
    title: 'Reserve Units',
    path: '/register',
  },
  {
    title: 'Customer Login',
    path: '/login',
  },
]

const NavItemsUser: Array<{ title: string; path: string }> = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Units',
    path: '/units',
  },
  {
    title: 'Portal',
    path: '/portal',
  },
  {
    title: 'Logout',
    path: '/logout',
  },
]

const NavItemsAdmin: Array<{ title: string; path: string }> = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Units',
    path: '/units',
  },
  {
    title: 'Admin',
    path: '/admin',
  },
  {
    title: 'Logout',
    path: '/logout',
  },
]

export const getNavItems = ({
  isAuthenticated,
  isAdmin,
  isRegister,
}: {
  isAuthenticated: boolean
  isAdmin: boolean
  isRegister: boolean
}) => {
  if (isAdmin && isAuthenticated) return NavItemsAdmin
  if (isAuthenticated && !isRegister) return NavItemsUser
  return NavItems
}
